import priceListService from "../../../../services/items/prices/price.service";
import { priceListActionTypes } from "../../../actionTypes/items/prices/price.actionTypes";

// Add Price List
export const addPriceList = (priceListData) => async (dispatch) => {
  try {
    dispatch({ type: priceListActionTypes.START_ADD_PRICE_LIST });
    const response = await priceListService.addPriceList(priceListData);
    dispatch({
      type: priceListActionTypes.ADD_PRICE_LIST_SUCCESS,
      data: response.data.payload,
    });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Add price list error:", ex.message);
    dispatch({ type: priceListActionTypes.ADD_PRICE_LIST_FAILURE, error: ex.response?.data });
    throw ex.response?.data; // Return error
  }
};

// Update Price List
export const updatePriceList = (priceListData) => async (dispatch) => {
  try {
    dispatch({ type: priceListActionTypes.START_UPDATE_PRICE_LIST });
    const response = await priceListService.updatePriceList(priceListData);
    dispatch({
      type: priceListActionTypes.UPDATE_PRICE_LIST_SUCCESS,
      data: response.data.payload,
    });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Update price list error:", ex.message);
    dispatch({ type: priceListActionTypes.UPDATE_PRICE_LIST_FAILURE, error: ex.response?.data });
    throw ex.response?.data; // Return error
  }
};

// Delete Price List
export const deletePriceList = (priceListId) => async (dispatch) => {
  try {
    dispatch({ type: priceListActionTypes.START_DELETE_PRICE_LIST });
    const response = await priceListService.deletePriceList(priceListId);
    dispatch({ type: priceListActionTypes.DELETE_PRICE_LIST_SUCCESS });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Delete price list error:", ex.message);
    dispatch({ type: priceListActionTypes.DELETE_PRICE_LIST_FAILURE, error: ex.response?.data });
    throw ex.response?.data; // Return error
  }
};

// Get Price Lists (Paginated)
export const getPriceLists = (queryParams) => async (dispatch) => {
  try {
    dispatch({ type: priceListActionTypes.START_GET_PRICE_LISTS });
    const response = await priceListService.getPriceLists(queryParams);
    dispatch({
      type: priceListActionTypes.GET_PRICE_LISTS_SUCCESS,
      data: response.data.payload,
    });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Get price lists error:", ex.message);
    dispatch({ type: priceListActionTypes.GET_PRICE_LISTS_FAILURE, error: ex.response?.data });
    throw ex.response?.data; // Return error
  }
};

// Add Price
export const addPrice = (priceData) => async (dispatch) => {
  try {
    dispatch({ type: priceListActionTypes.START_ADD_PRICE });
    const response = await priceListService.addPrice(priceData);
    dispatch({
      type: priceListActionTypes.ADD_PRICE_SUCCESS,
      data: response.data.payload,
    });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Add price error:", ex.message);
    dispatch({ type: priceListActionTypes.ADD_PRICE_FAILURE, error: ex.response?.data });
    throw ex.response?.data; // Return error
  }
};

// Update Price
export const updatePrice = (priceData) => async (dispatch) => {
  try {
    dispatch({ type: priceListActionTypes.START_UPDATE_PRICE });
    const response = await priceListService.updatePrice(priceData);
    dispatch({
      type: priceListActionTypes.UPDATE_PRICE_SUCCESS,
      data: response.data.payload,
    });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Update price error:", ex.message);
    dispatch({ type: priceListActionTypes.UPDATE_PRICE_FAILURE, error: ex.response?.data });
    throw ex.response?.data; // Return error
  }
};

const priceListActions = {
  addPriceList,
  updatePriceList,
  deletePriceList,
  getPriceLists,
  addPrice,
  updatePrice,
};

export default priceListActions;
